export default __webpack_public_path__ + "static/media/t_12_2026.7a4d3a21.png";